import { UntypedFormControl, ValidationErrors } from "@angular/forms";


export function noPipeCharacterValidator(control:UntypedFormControl): ValidationErrors | null{

    const value = control.value;
    return value && value.includes('|') ? 
    { noPipe:true} : null;

}